import React from "react";
import "./MenuItem.css";

const MenuItem = ({ title, price, tags }) => (
  <div className="app__menuitem">
    <div className="app__menuitem-head">
      <div className="app__menuitem-name">
        <p className=" menuitem__title">{title}</p>
      </div>

      <div className="app__menuitem-dash" />

      <div className="app__menuitem-price">
        <p className=" menuitem__price">{price}</p>
      </div>
    </div>
    <div className="app__menuitem-sub">
      <p className=" menuitem__tags">{tags}</p>
    </div>
  </div>
);

export default MenuItem;
